import {commonError} from '@core/helpers/commonError';

export const genericErrorMessage = 'errors.generic';
export const genericError = commonError({
  title: 'labels.error',
  message: genericErrorMessage
});
export const genericErrorGenerator = () => genericError;

